import gql from 'graphql-tag'

export const MapsCoordsFieldsFragment = gql`
  fragment MapsCoordsFields on MapsCoords {
    latitude
    longitude
  }
`
